import { GetTwoFactorSetupResponse } from '../../../../types/requests';
import { ConstructGet } from '../../../types/ConstructGet';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { TWO_FACTOR_BASE_PATH } from '../constants/twoFactorBasePath';

export const getTwoFactorSetup = (
  constructGet: ConstructGet,
  method: string,
): Promise<NonPaginatedResponse<GetTwoFactorSetupResponse> | undefined> =>
  constructGet<NonPaginatedResponse<GetTwoFactorSetupResponse>>(
    `${TWO_FACTOR_BASE_PATH}/setup`,
    { params: { method } },
    { preventDefaultErrorToast: true },
  );
